<template>
  <div>
    <Header title="Semua Transaksi" />
    <div class="py-3 py-md-5">
      <Tabs class="mb-custom" />
    </div>
  </div>
</template>

<script>
import Header from "../components/Catalog/Header";
import Tabs from "../components/Catalog/Tabs";
export default {
  components: {
    Header,
    Tabs
  }
};
</script>

<style>
.mb-custom {
  margin-bottom: 7rem;
}
</style>
